import {Component, Input} from "@angular/core";

@Component({
    selector: 'db-blocker-screen',
    templateUrl: './blocker-screen.component.html',
    styleUrls: ['./blocker-screen.component.scss'],
    standalone: false
})
export class BlockerScreenComponent {

  @Input() blockerMessage: string;

}
